import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { parse, format, isValid } from 'date-fns';

const parseDateValue = (value, dateFormat) => {
  if (value == null || value === '') {
    return null;
  }
  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }
  const stringValue = String(value);
  if (stringValue.includes('T')) {
    const isoDate = new Date(stringValue);
    if (isValid(isoDate)) {
      return isoDate;
    }
  }
  const parsed = parse(stringValue, dateFormat, new Date());
  return isValid(parsed) ? parsed : null;
};

const toBoundaryDate = (value) => {
  if (value == null || value === '') {
    return undefined;
  }
  if (value instanceof Date) {
    return isValid(value) ? value : undefined;
  }
  const parsed = new Date(value);
  return isValid(parsed) ? parsed : undefined;
};

const BrokerDatePicker = React.forwardRef(({
  value,
  onChange,
  onBlur,
  format: dateFormat = 'dd-MM-yyyy',
  label,
  disabled,
  readOnly,
  disableFuture,
  disablePast,
  minDate,
  maxDate,
  className,
  fullWidth = true,
  margin = 'normal',
  error,
  helperText,
  id,
  name,
  inputRef,
  InputProps,
  slotProps: externalSlotProps,
  ...rest
}, ref) => {
  const parsedValue = parseDateValue(value, dateFormat);
  const isReadOnly = readOnly || InputProps?.readOnly;

  return (
    <DatePicker
      label={label}
      value={parsedValue}
      onChange={(date) => {
        onChange?.(date ? format(date, dateFormat) : null);
      }}
      disabled={disabled || isReadOnly}
      disableFuture={disableFuture}
      disablePast={disablePast}
      minDate={toBoundaryDate(minDate)}
      maxDate={toBoundaryDate(maxDate)}
      format={dateFormat}
      slotProps={{
        ...externalSlotProps,
        textField: {
          ...externalSlotProps?.textField,
          ref: inputRef || ref,
          id,
          name,
          className,
          fullWidth,
          margin,
          error: Boolean(error),
          helperText,
          onBlur,
          InputProps: {
            ...InputProps,
            readOnly: isReadOnly,
          },
        },
      }}
      {...rest}
    />
  );
});

BrokerDatePicker.displayName = 'BrokerDatePicker';

export default BrokerDatePicker;
